import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { IdReferenceList } from "../../helper/IdReferenceList";

export const TutorialDisplayRecord = Record({
  groups: new IdReferenceList(),
  activeTutorial: null,
  visibleTutorial: null,
  tutorialIsActive: false
});

const data = {
  idLists: {
    groups: "TutorialGroupDisplayRecord"
  }
};

createFromJS.registerCallback("TutorialDisplayRecord", createFromJS.createNestedCallback(TutorialDisplayRecord, data));
